import { api } from "@/services";

export async function loginRequest(user: string, password: string) {
  const { data } = await api.post(
    "Auth/LoginBeta",
    {
      account: user,
      password: password,
      grant_type: "password",
      minutes: 5
    },
    {
      headers: {
        "Content-Type": "application/json"
      }
    }
  );

  const status = data?.authenticated;
  const token = data?.accessToken || null;
  const refreshToken = data?.refreshToken || null;
  const id = data?.clienteId || null;
  const message = data?.message;
  const email = data?.email;
  console.log("ajuda deus", token, refreshToken, id, message, status, email);
  return { token, refreshToken, id, message, status, email };
}
